import React from 'react';
import Proptypes from 'prop-types';
import {
  Wrapper,
  IconWrapper,
  ContentWrapper,
  ActionWrapper,
  LinkTitle,
  LinkSubtitle,
  Button,
} from './styles';

const LinkItem = ({
  isPrime, title, subTitle, btnLabel, icon, url,
}) => {
  const handleClickAction = () => {
    window.location.href = `${url && url}`;
  };

  return (
    <Wrapper prime={isPrime}>
      <IconWrapper>
        <img src={icon && icon} alt="" />
      </IconWrapper>
      <ContentWrapper>
        <LinkTitle>{title && title}</LinkTitle>
        <LinkSubtitle>{subTitle && subTitle}</LinkSubtitle>
      </ContentWrapper>
      <ActionWrapper>
        <Button onClick={handleClickAction} prime={isPrime}>
          {btnLabel && btnLabel}
        </Button>
      </ActionWrapper>
    </Wrapper>
  );
};

LinkItem.defaultProps = {
  isPrime: false,
  title: '',
  subTitle: '',
  btnLabel: '',
  icon: '',
  url: '',
};

LinkItem.propTypes = {
  isPrime: Proptypes.bool,
  title: Proptypes.string,
  subTitle: Proptypes.string,
  btnLabel: Proptypes.string,
  icon: Proptypes.string,
  url: Proptypes.string,
};

export default LinkItem;
